const translations = {
    autoFill: 'Auto-fill',
    direction: 'Direction',
    gust: 'Gust mph',
    humidity: 'Humidity %',
    temperature: 'Temp °F',
    weatherConditions: 'Weather Conditions',
    weatherThresholdsInfo:
        'Weather thresholds are org defaults. Per-product thresholds require Agrian Compliance tier (v1.x).',
    windSpeed: 'Wind mph'
};

export default translations;
